/**
 * Check if an organisation is a team (sub-organisation)
 *
 * A team is an organisation that:
 * - has a parent organisation
 * - (previously also required client groups, but this is now optional)
 *
 * @param {Object} organisation - The organisation object to check
 * @returns {boolean} - True if the organisation is a team, false otherwise
 */
export function isTeam(organisation) {
  if (!organisation) {
    return false
  }

  const hasParent = !!organisation.parentOrganisation
  // const hasClientGroups = Array.isArray(organisation.clientGroups) && organisation.clientGroups.length > 0

  return hasParent // && hasClientGroups
}

/**
 * Check if an organisation is a top-level organisation (has no parent)
 *
 * A top-level organisation is one that does not have a parent organisation.
 * This check is independent of whether it has client groups or teams.
 *
 * @param {Object} organisation - The organisation object to check
 * @returns {boolean} - True if the organisation is top-level, false otherwise
 */
export function isTopLevelOrganisation(organisation) {
  if (!organisation) {
    return false
  }

  return !organisation.parentOrganisation
}

/**
 * Split an organisation into its parent ("Organisation") and team ("Team") names.
 * Mirrors the GA4 user-property logic in analyticsService.js: a team is an org
 * that has a parent organisation.
 *
 * @param {Object} organisation - Organisation object with optional parentOrganisation
 * @returns {{ organisation: string|null, team: string|null }}
 *   organisation = the parent org name (or the org's own name if it has no parent)
 *   team = the team name when the org is a child/team, else null
 */
export function getOrganisationAndTeam(organisation) {
  if (!organisation) {
    return { organisation: null, team: null }
  }

  if (isTeam(organisation)) {
    return {
      organisation: organisation.parentOrganisation?.name || null,
      team: organisation.name
    }
  }

  return { organisation: organisation.name, team: null }
}
